module.exports = __webpack_public_path__ + "img/logo-header.c8cbe51a.png";